import React, { useState } from 'react'
import '../css/campaigns_view_more_metrics_details.css'
import { getSvgIcons } from '../../../../helpers/getReactIcons'
import { restructure_ads_data } from '../../../../helpers/ads_helper_functions'
import LineChart from '../../../../components/client/dashboard/LineChart'

const CampaignsViewMoreMetricsDetails = (
    { adsData }

) => {
    const [selectedTab, setSelectedTab] = useState('Campaign Details')

    const { metricsData, campaignMetricsData ,graph_data} = restructure_ads_data(adsData)
 


    return (
        <div className='campaigns_view_more_metrics_details'>

            <section className="ad_details_metrics_overview">
                <div className="ad_details_metrics_container">
                    {/* <div className="ad_details_metrics_container_top d-none">
                        <div className="ad_details_metrics_heading_container">
                            <div className="ad_details_metrics_heading_container_top">
                                <div className="ad_details_metrics_heading_logo">
                                    <p>AD</p>
                                </div>
                                <div className="ad_details_metrics_heading_content">
                                    <h4></h4>
                                    <p>Ad ID:</p>

                                </div>

                            </div>
                            <div className="ad_details_metrics_heading_container_bottom">
                                <div className="ad_details_metrics_heading_status_badge">
                                    <span></span>
                                </div>
                                <p></p>

                            </div>

                        </div>

                    </div> */}
                    <div className="ad_details_metrics_container_bottom">


                        <div className="metrics_container">

                            <div className="ad_details_metrics_container_bottom_heading">
                                <p className="text-dark">Key Metrics</p>
                            </div>
                            <div className="ad_details_metrics_container_bottom_metrics_card_container d-flex flex-wrap">

                                {metricsData?.map((data) => {
                                    return <div className="ad_details_metrics_card" >
                                        <div className="ad_details_metrics_card_top">
                                            <span>{data?.icon}</span>
                                            <span>{data?.name}</span>
                                               <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={data?.description}>{getSvgIcons('info',{})}</span>
                                        </div>
                                        <div className="ad_details_metrics_card_bottom">
                                            <p>{data?.value ?? 0}</p>
                                            <div>
                                                <span>{getSvgIcons('arrow-up', { color: '#166556' })}</span>
                                                <span></span>
                                            </div>

                                        </div>
                                    </div>

                                })}



                            </div>

                        </div>

                    </div>
                </div>

            </section>

            {/* tabs section */}
            <section className='ad_details_tabs_section'>
                <div className=' tabs_section_container my-4'>
                    <div className='tab_section_wrapper_top '>
                        <div className='tab_section_wrapper_top_container'>
                            {['Campaign Details', 'Ad Details'].map((tab) => {
                                return <div onClick={() => setSelectedTab(tab)} className={`tab ${selectedTab === tab ? "tab_active" : ""}`}>
                                    <span>{tab}</span>
                                </div>

                            })}
                        </div>
                    </div>
                    <div className='tab_section_wrapper_bottom my-2'>
                        {selectedTab === "Performance" && (
                            <div className='performance_metrics_card'>
                                <div className='performance_metrics_card_top'>
                                    <h3> </h3>
                                </div>
                                <div className='performance_metrics_card_bottom'>

                                
                                </div>

                            </div>

                        )}
                        {selectedTab === "Campaign Details" && (
                            <div className='performance_metrics_card p-4'>
                                <div className='performance_metrics_card_top'>
                                    <h3>Campaign Details</h3>
                                </div>
                                <div className='performance_metrics_card_bottom'>




                                    <div className="ad_details_metrics_container_bottom">
                                        <div className='custom_border  d-flex   w-100 p-4 border_radius_sm'>
                                            <div className=' d-flex align-items-center justify-content-md-between w-100'>
                                                <div>
                                                    <p className='text_muted text_base text_light'>Campaign Id</p>

                                                    <span className='text_dark text_lg text_medium'>{adsData?.external_campaign_details?.campaign_id}</span>
                                                </div>
                                                <div>
                                                    <p className='text_muted text_base text_light'>Campaign Name</p>
                                                    <span className='text_dark text_lg text_medium'>{adsData?.external_campaign_details?.campaign_name}</span>
                                                </div>
                                                <div>
                                                    <p className='text_muted text_base text_light'>Duration</p>
                                                    <span className='text_dark text_lg text_medium'>{adsData?.external_campaign_details?.start_date}</span> - <span className='text_dark text_lg text_medium'>{adsData?.external_campaign_details?.end_date}</span>
                                                </div>

                                            </div>
                                            <div>

                                            </div>

                                        </div>

                                        <div className="metrics_container p-0 py-4">

                                            <div className="ad_details_metrics_container_bottom_heading">
                                                <p className="text-dark">Campaign Key Metrics</p>
                                            </div>
                                            <div className="ad_details_metrics_container_bottom_metrics_card_container d-flex flex-wrap">


                                                {campaignMetricsData?.map((data) => {
                                                    return <div className="ad_details_metrics_card" >
                                                        <div className="ad_details_metrics_card_top">
                                                            <span>{data?.icon}</span>
                                                            <span>{data?.name}</span>
                                                        </div>
                                                        <div className="ad_details_metrics_card_bottom">
                                                            <p>{data?.value ?? 0}</p>
                                                            <div>
                                                                <span>{getSvgIcons('arrow-up', { color: '#166556' })}</span>
                                                                <span></span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                })}



                                            </div>

                                        </div>

                                    </div>



                                </div>

                            </div>

                        )}
                        {selectedTab === "Ad Details" && (
                            <div className='performance_metrics_card'>
                                <div className='performance_metrics_card_top'>
                                    <h3>Ad Performance</h3>
                                </div>
                                <div className='performance_metrics_card_bottom'>

                                  <LineChart graph_data={graph_data} title="Clicks / Impressions / Share" />

                                </div>

                            </div>

                        )}





                    </div>

                </div>



            </section>


        </div>
    )
}

export default CampaignsViewMoreMetricsDetails